import React, { useState } from "react";
import { If } from "react-condition";
import { useHistory, Link } from "react-router-dom";
import { useEffect } from "react";
import logo from "../images/Maxicus_logo.png";
import ChangePassword from "../pages/Authentication/ChangePassword";

function NavbarCandidate() {
  const history = useHistory();
  const [loggedIn, setLoggedIn] = useState(false);

  useEffect(() => {
    if (
      localStorage.getItem("candidate.token") !== null &&
      localStorage.getItem("candidate.name") !== null &&
      localStorage.getItem("candidate.email") !== null &&
      localStorage.getItem("candidate.id") !== null
    ) {
      setLoggedIn(true);
    }
  }, []);

  function onClickLogout(event) {
    event.preventDefault();
    localStorage.removeItem("candidate.name");
    localStorage.removeItem("candidate.token");
    localStorage.removeItem("candidate.email");
    localStorage.removeItem("candidate.id");
    history.push("/careers");
  }

  return (
    <nav className="navbar navbar-expand navbar-light bg-white topbar mb-4 mt-0 static-top shadow">
      <div className="container-fluid">
        <ul className="navbar-nav">
          <li className="nav-item">
            <a
              className="nav-link nav-link-black nav-link-bold nav-brand"
              href="#/"
            >
              <img src={logo} alt="" />
            </a>
          </li>
        </ul>

        <ul className="navbar-nav ml-auto">
          <If test={loggedIn}>
            <li className="nav-item">
              <Link to="/careers/home" className="nav-link nav-link-black">
                {/* Application Status */}
              </Link>
            </li>
          </If>

          {/* <li className="nav-item">
            <a className="nav-link nav-link-black" href="#/">
              Our Company
            </a>
          </li>
          <li className="nav-item">
            <a className="nav-link nav-link-black" href="#/">
              Meet Our Team
            </a>
          </li> */}
          {/* <If test={loggedIn}>
            <li className="nav-item">
              <a
                href="#/"
                className="nav-link nav-link-black"
                onClick={onClickLogout}
              >
                Logout
              </a>
            </li>
          </If> */}
        </ul>
        <ul className="navbar-nav">
          <li className="nav-item dropdown no-arrow">
            <a
              className="nav-link dropdown-toggle"
              href="#/"
              id="userDropdown"
              role="button"
              data-toggle="dropdown"
            >
              <span
                className="mr-3 d-none d-lg-inline text-gray-600 "
                style={{ fontWeight: 700 }}
              >
                <i className="fa fa-user fa-fw"></i>
                {localStorage.getItem("candidate.name")}
              </span>
            </a>

            <div className="dropdown-menu dropdown-menu-right shadow animated--grow-in">
              <a className="dropdown-item" href="#/">
                <i className="fas fa-user fa-sm fa-fw mr-2 text-gray-400"></i>
                Profile
              </a>
              <ChangePassword component="career" />
              <div className="dropdown-divider"></div>
              <button className="dropdown-item" onClick={onClickLogout}>
                <i className="fas fa-sign-out-alt fa-sm fa-fw mr-2 text-gray-400"></i>
                Logout
              </button>
            </div>
          </li>
        </ul>
      </div>
    </nav>
  );
}

export default NavbarCandidate;
